import React, { useState, useRef, useEffect } from "react";
import { getAPIClient } from "../apiClient";
import { getAuth } from "firebase/auth";
import logout from "../utils/logout";
import { useNavigate } from "react-router";
import { stopPolling } from "../utils/polling";
import { BiometricAuth, BiometryType } from "@aparajita/capacitor-biometric-auth";
import { Capacitor } from "@capacitor/core";

const lockImages = [
  "/assets/images/Lock_1.png",
  "/assets/images/Lock_2.png",
  "/assets/images/Lock_3.png",
  "/assets/images/Lock_2.png",
  "/assets/images/Lock_1.png",
];

export default function BiometricsLockout() {
  const navigate = useNavigate();
  const [imageIndex, setImageIndex] = useState(0);
  const [biometryType, setBiometryType] = useState<BiometryType | null>(null);

  const intervalRef = useRef<NodeJS.Timer | null>(null);

  const authenticate = async () => {
    try {
      await BiometricAuth.authenticate({
        allowDeviceCredential: true,
      });
      navigate("/home/records");
    } catch (error) {
      // Fail silently for now since a user can retry manually via button.
    }
  };

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      BiometricAuth.checkBiometry().then((value) => {
        if (value.isAvailable) {
          setBiometryType(value.biometryType);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (biometryType) {
      authenticate();
    }
  }, [biometryType]);

  // React Web does not have an Image Sequence component, unlike React Native.
  useEffect(() => {
    const frameDuration = 1000 / 6;

    intervalRef.current = setInterval(() => {
      setImageIndex((prev) => {
        const next = prev + 1;
        return next < lockImages.length ? next : 0;
      });
    }, frameDuration);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [lockImages]);

  const handleBackToLogin = async () => {
    stopPolling();
    await logout(getAPIClient(), getAuth());
    navigate("/");
  };

  return (
    <div className="flex flex-col gap-12 p-4 h-screen dark:bg-dark">
      <img src={lockImages[imageIndex]} className="h-[150px] w-[120px] mx-auto mt-16" />
      <p className="text-white font-semibold text-xl">
        Unlock Docket® with your biometrics or logout and login with your email.
      </p>
      <div className="flex flex-col gap-6">
        <button className="btn text-lg docket-button-responsive" onClick={() => authenticate()}>
          Log-in with Face ID
        </button>
        <button
          className="btn text-lg docket-button-responsive"
          onClick={() => handleBackToLogin()}
        >
          Back To Login
        </button>
      </div>
    </div>
  );
}
